import { headerSizes } from '../elements/RedesignedHeader/const';
import { BREAKPOINTS } from './breakponts';

export default {
  contentHeight: {
    height: `calc(100vh - ${headerSizes.HEADER}px)`,
  },
  absoluteContentHeight: {
    top: `${headerSizes.HEADER}px!important`,
    height: `calc(100% - ${headerSizes.HEADER}px)`,
  },
  fullScreenMobilePopover: {
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      top: '0!important',
      left: '0!important',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  }
};